// Place of Service codes as defined by CMS (Centers for Medicare & Medicaid Services)
// These codes are used to identify the setting where services were provided

export const PLACE_OF_SERVICE_CODES: Record<string, string> = {
  '01': 'Pharmacy',
  '02': 'Telehealth Provided Other than in Patient\'s Home',
  '03': 'School',
  '04': 'Homeless Shelter',
  '05': 'Indian Health Service Free-standing Facility',
  '06': 'Indian Health Service Provider-based Facility',
  '07': 'Tribal 638 Free-standing Facility',
  '08': 'Tribal 638 Provider-based Facility',
  '09': 'Prison/Correctional Facility',
  '10': 'Telehealth Provided in Patient\'s Home',
  '11': 'Office',
  '12': 'Home',
  '13': 'Assisted Living Facility',
  '14': 'Group Home',
  '15': 'Mobile Unit',
  '16': 'Temporary Lodging',
  '17': 'Walk-in Retail Health Clinic',
  '18': 'Place of Employment-Worksite',
  '19': 'Off Campus-Outpatient Hospital',
  '20': 'Urgent Care Facility',
  '21': 'Inpatient Hospital',
  '22': 'On Campus-Outpatient Hospital',
  '23': 'Emergency Room - Hospital',
  '24': 'Ambulatory Surgical Center',
  '25': 'Birthing Center',
  '26': 'Military Treatment Facility',
  '31': 'Skilled Nursing Facility',
  '32': 'Nursing Facility',
  '33': 'Custodial Care Facility',
  '34': 'Hospice',
  '41': 'Ambulance - Land',
  '42': 'Ambulance - Air or Water',
  '49': 'Independent Clinic',
  '50': 'Federally Qualified Health Center',
  '51': 'Inpatient Psychiatric Facility',
  '52': 'Psychiatric Facility - Partial Hospitalization',
  '53': 'Community Mental Health Center',
  '54': 'Intermediate Care Facility/Individuals with Intellectual Disabilities',
  '55': 'Residential Substance Abuse Treatment Facility',
  '56': 'Psychiatric Residential Treatment Center',
  '57': 'Non-residential Substance Abuse Treatment Facility',
  '58': 'Non-residential Opioid Treatment Facility',
  '60': 'Mass Immunization Center',
  '61': 'Comprehensive Inpatient Rehabilitation Facility',
  '62': 'Comprehensive Outpatient Rehabilitation Facility',
  '65': 'End-Stage Renal Disease Treatment Facility',
  '71': 'Public Health Clinic',
  '72': 'Rural Health Clinic',
  '81': 'Independent Laboratory',
  '99': 'Other Place of Service',
};

export const getPlaceOfServiceDescription = (code: string | null): string => {
  if (!code) return 'Unknown';
  return PLACE_OF_SERVICE_CODES[code] || `Unknown (${code})`;
};

// Common place of service categories for quick reference
export const COMMON_PLACE_OF_SERVICE = {
  OFFICE: '11',
  INPATIENT_HOSPITAL: '21',
  OUTPATIENT_HOSPITAL: '22',
  EMERGENCY_ROOM: '23',
  AMBULATORY_SURGICAL_CENTER: '24',
  SKILLED_NURSING_FACILITY: '31',
  HOME: '12',
  URGENT_CARE: '20',
  INDEPENDENT_LAB: '81',
};
